import axios from "axios";
import { config } from "../utils/conf";
import { requestHeaders } from "../utils/http";
// import { sessionService } from "redux-react-session";
import { sessionService } from "./../auth-service/index";
import { getUser } from "../utils/JwtService";
import { fetchUserProfile } from "../utils/userProfile";

export const updatePassword = (accessToken, user) => {
  return {
    type: "PASSWORD_UPDATE",
    payload: axios.post(
      `${config.authenticationApiUrl}/v1/users/password-update`,
      user,
      {
        headers: requestHeaders(accessToken),
      },
    ),
  };
};

export const login = (user) => {
  return {
    type: "LOGIN",
    payload: axios
      .post(
        `${config.authenticationApiUrl}/v1/login`,
        {
          userName: user.userName,
          password: user.password,
        },
        {
          headers: requestHeaders(),
        },
      )
      .then(async (response) => {
        await saveSession(response);
        return response;
      })
      .catch((err) => {
        sessionService.saveUser({ error: err });
        throw err;
      }),
  };
};

export const authorization = (token) => {
  return {
    type: "AUTHORIZATION",
    payload: axios
      .post(
        `${config.authenticationApiUrl}/v1/authorize`,
        {},
        {
          headers: requestHeaders(token),
        },
      )
      .then(async (response) => {
        await saveSession(response);
        return response;
      })
      .catch((err) => {
        sessionService.saveUser({ error: err });
        throw err;
      }),
  };
};

async function saveSession(response) {
  const accessToken = response.data.accessToken;
  const jwtUser = getUser(accessToken);
  const profileUser = await fetchUserProfile(accessToken, jwtUser);

  await sessionService.saveSession(response.data.accessToken);

  await sessionService.saveUser({
    ...jwtUser,
    ...profileUser,
    initialUser: {
      ...jwtUser,
      ...profileUser,
      accessToken,
    },
    accessToken,
  });

  return true;
}
